
import { Component, Vue, Prop } from "vue-property-decorator";
import { Variables } from "../../variables";
import { accountApi } from "../services/api/account/account";
import { UpdateProfileDataCommand } from "../services/api/models/UpdateProfileDataCommand.model";
import { UpdateProfilePhotoCommand } from "../services/api/models/UpdateProfilePhotoCommand.model";
import PhonePrefix from "../components/PhonePrefix.vue";
import Nationality from "../components/Nationality.vue";
import TransitionMessage from "./TransitionMessage.vue";
import moment from "moment";

@Component({
  components: { PhonePrefix, Nationality, TransitionMessage },
})
export default class UserProfile extends Vue {
  @Prop() readonly profile: any;

  private subjectId = "";
  private picture = "";
  private publicProfile = "";
  private givenName = "";
  private familyName = "";
  private cedula = "";
  private birthDate = "";
  private passport = "";
  private passportIssuanceDate = "";
  private passportExpirationDate = "";
  private email = "";
  private phonePrefix = "";
  private phone = "";
  private nationality = "";
  private address = "";

  private errorMessageShow = false;
  private errorMessage = "";
  private profilePhotoRefreshTime = "";
  private showProfilePhotoModal = false;
  private isSavingProfile = false;
  private showNationalityRequiredError = false;
  private profilePhotoName = "";
  private profilePhotoBase64 = "";
  private profilePhotoUpdating = false;

  $t: any;
  $refs!: {
    inputProfilePhoto: HTMLInputElement;
  };

  get profilePicture() {
    return `${Variables.ApiBaseUrl}/api/profile/photo/${this.picture}?${this.profilePhotoRefreshTime}`;
  }

  get profileQr() {
    return `${Variables.ApiBaseUrl}/api/profile/qr/${this.subjectId}`;
  }

  async mounted() {
    await this.load();
  }

  async load() {
    let profile = this.profile;
    this.subjectId = profile.subject;
    this.picture = profile.profilePhoto;
    this.publicProfile = profile.publicProfileUrl;
    this.givenName = profile.givenName;
    this.familyName = profile.familyName;
    this.cedula = profile.cedula ?? "";
    this.birthDate = profile.birthday
      ? moment(profile.birthday).format("YYYY-MM-DD")
      : "";
    this.passport = profile.passport ?? "";
    this.passportIssuanceDate = profile?.passportIssuanceDate
      ? moment(profile.passportIssuanceDate).format("YYYY-MM-DD")
      : "";
    this.passportExpirationDate = profile.passportExpirationDate
      ? moment(profile.passportExpirationDate).format("YYYY-MM-DD")
      : "";
    this.email = profile.email;

    if (profile && profile.phone) {
      var phone = await profile.phone.split(" ");
      if (phone.length > 1) {
        this.selectedPrefix(phone[0]);
        this.phone = phone[1];
      }
    }

    this.nationality = await profile.nationality;
    this.address = profile.address;
  }

  selectedPrefix(prefix: string) {
    this.phonePrefix = prefix;
  }

  async saveProfile() {
    this.isSavingProfile = true;
    this.errorMessageShow = false;
    this.errorMessage = "";
    const phone =
      this.phonePrefix && this.phone ? `${this.phonePrefix} ${this.phone}` : "";

    if (this.nationality === "") {
      this.isSavingProfile = false;
      this.showNationalityRequiredError = true;
      return;
    }

    try {
      const data = new UpdateProfileDataCommand(
        this.cedula,
        this.passport,
        this.passportIssuanceDate,
        this.passportExpirationDate,
        this.birthDate,
        this.email,
        phone,
        this.address,
        this.nationality
      );

      await accountApi.updateProfile(data);
      this.isSavingProfile = false;
    } catch (error) {
      this.isSavingProfile = false;
      if (error?.response?.data) {
        this.errorMessageShow = true;
        this.errorMessage = this.$t(`errors.${error.response.data}`);
      }
    } finally {
      this.isSavingProfile = false;
    }
  }

  async changeProfilePhoto(event: any) {
    let input = event.target as HTMLInputElement;
    let files = input.files;
    if (files !== null && files.length > 0) {
      let file = files.item(0);
      if (file !== null) {
        this.profilePhotoName = file.name;
        try {
          this.profilePhotoBase64 = await this.toBase64(file);
          return;
        } catch (err) {
          window.console.log(err);
        }
      }
    }
    this.profilePhotoName = "";
    this.profilePhotoBase64 = "";
  }

  toBase64(file: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        let src = reader.result as string;
        let base64 = await this.toJpeg(src);
        resolve(base64);
      };
      reader.onerror = (err) => reject(err);

      reader.readAsDataURL(file);
    });
  }

  toJpeg(src: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const canvas = document.createElement("canvas") as HTMLCanvasElement;
        canvas.width = width;
        canvas.height = height;
        let context = canvas.getContext("2d")!;
        context.fillStyle = "#fff";
        context.fillRect(0, 0, width, height);
        context.drawImage(img, 0, 0);
        const base64 = canvas.toDataURL("image/jpeg");
        resolve(base64);
      };
      img.onerror = (err) => reject(err);

      img.src = src;
    });
  }

  async deleteProfilePhoto() {
    this.profilePhotoName = "";
    this.profilePhotoBase64 = "";
    await this.saveProfilePhoto();
  }

  async saveProfilePhoto() {
    this.profilePhotoUpdating = true;
    try {
      await accountApi.updateProfilePhoto(
        new UpdateProfilePhotoCommand(
          this.profilePhotoBase64?.split("base64,")[1] ?? ""
        )
      );
    } catch (err) {
      window.console.log(err);
    }

    await this.load();
    this.profilePhotoRefreshTime = new Date().getTime().toString();
    this.showProfilePhotoModal = false;
    this.profilePhotoName = "";
    this.profilePhotoBase64 = "";
    this.$refs.inputProfilePhoto.value = "";
    this.profilePhotoUpdating = false;
  }

  formatDate(date: any) {
    if (date != null || date != "") {
      return moment(date).format("DD/MM/YYYY");
    }

    return date;
  }
}
